import api from "../api"
const DEFAULT_PRESET_ID = 0
export default {
	async getPresets(id) {
		let presetID = id || DEFAULT_PRESET_ID
		let value = await api.get(`/presets/${presetID}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async list() {
		let value = await api.get(`/presets/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}
}